<script>
export default {
  name: 'BaseButton',
}
</script>

<template>
  <el-button class="tamara-base-button" v-bind="$attrs" v-on="$listeners">
    <slot />
  </el-button>
</template>

<style lang="scss" scoped>
@import '@/styles/lavender/design.scss';

.tamara-base-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: var(--tamara-spacing-sm) var(--tamara-spacing-md);
  font-weight: 700;
  text-align: center;
  border: 1px solid var(--tamara-color-functional-grey-light);
  border-radius: var(--tamara-border-radius-full);

  @extend .tamara-body-large;

  &::v-deep {
    &.el-button--primary {
      color: var(--tamara-color-text-light-primary);
      background-color: var(--tamara-color-primary);

      &:active,
      &:focus,
      &:hover {
        opacity: 0.8;
      }
    }

    &.el-button--secondary {
      color: var(--tamara-color-text-secondary);
      background-color: var(--tamara-background-color-secondary);

      &:active,
      &:focus,
      &:hover {
        border-color: var(--tamara-color-primary);
      }
    }

    &.el-button--default {
      &:active,
      &:focus,
      &:hover {
        color: var(--tamara-color-text-light-primary);
        background-color: var(--tamara-color-primary);
      }
    }

    &.el-button--info {
      color: var(--tamara-color-text-light-primary);
      background-color: var(--tamara-color-functional-grey);
    }

    &.el-button--text {
      color: var(--tamara-color-primary);
      background-color: transparent;
      border: none;

      &:hover {
        color: var(--tamara-color-text-secondary);
        background-color: transparent;
      }
    }

    &.el-button--outline {
      color: var(--tamara-color-primary);
      background-color: transparent;
      border: 1px solid var(--tamara-color-primary);

      &:hover {
        color: var(--tamara-color-text-light-primary);
        background-color: var(--tamara-color-primary);
      }
    }

    &.is-circle {
      &.el-button--medium {
        width: 40px;
        height: 40px;
        padding: var(--tamara-spacing-sm);
      }
    }

    &.is-disabled {
      color: var(--tamara-color-text-light-disabled);
      background-color: var(--tamara-color-background-light-disabled);
      border-color: var(--tamara-color-background-light-disabled);

      &:active,
      &:focus,
      &:hover {
        color: var(--tamara-color-text-light-disabled);
        background-color: var(--tamara-color-background-light-disabled);
        border-color: var(--tamara-color-background-light-disabled);
      }
    }
  }
}
</style>
